import {Component, computed, inject, input, output} from '@angular/core';
import {IItem} from '../../../../types/IItem';
import {ItemImageComponent} from '../../../../shared/components/item-image/item-image.component';
import {TitleCasePipe} from '@angular/common';
import {Modal} from '../../../../shared/components/modal/modal';
import {ResultsStore} from '../../../../shared/store/results.store';
import {getFeatures, getFeatureString} from '../../../../shared/utils/item.utils';
import {IconsComponent} from '../../../../shared/components/icons/icons.component';
import {LinkComponent} from '../../../../shared/components/link/link.component';
import {EventService} from '../../../../shared/services/event.service';
import {AccessService} from '../../../../shared/services/access.service';

@Component({
  selector: 'app-results-item-details-modal',
  imports: [
    ItemImageComponent,
    TitleCasePipe,
    Modal,
    IconsComponent,
    LinkComponent,
  ],
  templateUrl: './results-item-details-modal.html',
  styleUrl: './results-item-details-modal.css',
})
export class ResultsItemDetailsModal {
  item = input.required<IItem>();
  isOpen = input.required<boolean>();

  eventService = inject(EventService);
  access = inject(AccessService);

  isOpenChange = output<void>();

  public resultsStore = inject(ResultsStore);

  protected readonly getFeatures = getFeatures;
  protected readonly getFeatureString = getFeatureString;

  readonly editItemVisible = computed(() => this.access.has('edit_item'));
  readonly editItemDisabled = computed(() => this.access.cannot('edit_item'));

  readonly itemHistoryVisible = computed(() => this.access.has('view_item_history'));
  readonly itemHistoryDisabled = computed(() => this.access.cannot('view_item_history'));
}
